'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { Container, Row } from 'reactstrap';
import { JobsSearchResponse } from 'shared/api/jobs';
import Jobs from 'shared/components/Jobs';
import { Locale, SynergiejobsDictionary } from 'shared/i18n/i18n-config';
import AppLayout from '../../../components/AppLayout';

function JobPage({
  jobData,
  locale,
  dictionary,
  nextPageSearchParams,
}: {
  nextPageSearchParams: NextPageSearchParams;
  jobData: JobsSearchResponse;
  locale: Locale;
  dictionary: SynergiejobsDictionary;
}) {
  return (
    <AppLayout
      className="jobsPage"
      availableLocales={[
        { locale: 'nl', pathname: '/jobs/' },
        { locale: 'fr', pathname: '/jobs/' },
        { locale: 'en', pathname: '/jobs/' },
        { locale: 'pl', pathname: '/jobs/' },
        { locale: 'ro', pathname: '/jobs/' },
      ]}
      dictionary={dictionary}
    >
      <Container>
        <Row>
          <Jobs jobData={jobData} dictionary={dictionary} locale={locale} nextPageSearchParams={nextPageSearchParams} />
        </Row>
      </Container>
    </AppLayout>
  );
}

export default JobPage;
